<script>
export default {
  name: 'configuration',
  computed: {
    dailyReservationsEnabled () {
      return !!this.$store.state.config.company.daily_reservations;
    },
    discountsEnabled () {
      return !!this.$store.state.config.company.discounts;
    },
    workersEnabled () {
      return !!this.$store.state.config.company.workers;
    },
    paymentsEnabled () {
      return !!this.$store.state.config.company.payment;
    },
    smsEnabled () {
      return !!this.$store.state.config.company.sms;
    },
    servicesEnabled () {
      return !!this.$store.state.config.company.services;
    },
    parametersEnabled () {
      return !!this.$store.state.config.company.reservation_parameters;
    },
    periodicityEnabled () {
      return !!this.$store.state.config.company.periodicity;
    },
    waitingListEnabled () {
      return !!this.$store.state.config.company.waiting_list;
    },
    multilanguageEnabled () {
      return !!this.$store.state.config.company.multilang;
    },
    googleCalendarEnabled () {
      return !!this.$store.state.config.company.google_calendar;
    },
    outlookCalendarEnabled () {
      return !!this.$store.state.config.company.outlook_calendar;
    },
    peopleNumberEnabled () {
      return !!this.$store.state.config.company.people_required;
    },
    pluginCartEnabled () {
      return !!this.$store.state.config.company.cart_enabled;
    },
    workersVisible () {
      return !!this.$store.state.config.company.show_workers;
    },
    ticketsEnabled () {
      return !!this.$store.state.config.permissions.tickets;
    },
    invoicesEnabled () {
      return !!this.$store.state.config.permissions.fakturownia_api && !!this.$store.state.config.company.fakturownia_api;
    },
    getResponseEnabled () {
      return !!this.$store.state.config.permissions.getresponse && !!this.$store.state.config.company.getresponse;
    },
    attendancesListEnabled () {
      return !!this.$store.state.config.company.attendances_list && !!this.$store.state.config.permissions.attendances_list;
    },
    surveysAvailable () {
      return !!this.$store.state.config.permissions.surveys;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/Configuration.vue